import React from "react";
import {
  TextField,
  InputAdornment,
  IconButton,
  Divider,
  Autocomplete,
} from "@mui/material";
import {
  Close as CloseIcon,
  Search as SearchIcon,
} from "@mui/icons-material";
import usePlacesAutocomplete, {
  getGeocode,
  getLatLng,
} from "use-places-autocomplete";

const PlacesAutoComplete = ({ setLocation }) => {
  const {
    ready,
    value,
    setValue,
    suggestions: { status, data },
    clearSuggestions,
  } = usePlacesAutocomplete();

  const isLatLng = (input) => {
    const latLngRegex = /^(-?\d{1,3}\.\d+)[,\s]+(-?\d{1,3}\.\d+)$/;
    return latLngRegex.test(input);
  };

  const handleSelectPlace = async (event, val) => {
    if (!val) return;

    setValue(val, false);
    clearSuggestions();

    if (isLatLng(val)) {
      const [lat, lng] = val.split(/[,\s]+/).map(Number);
      setLocation({
        lat: lat,
        lng: lng,
      });
      return;
    } else {
      const results = await getGeocode({ address: val });
      const { lat, lng } = await getLatLng(results[0]);
      setLocation({
        lat: lat,
        lng: lng,
      });
    }
  };

  const handleSearch = (event) => {
    if (!event || event.key === "Enter") {
      if (isLatLng(value)) {
        handleSelectPlace(null, value);
      }
    }
  };

  return (
    <Autocomplete
      freeSolo
      options={
        status === "OK" && Array.isArray(data)
          ? data.map(({ description }) => description)
          : []
      }
      disableClearable
      value={value}
      onInputChange={(event, newValue) => setValue(newValue)}
      onChange={handleSelectPlace}
      disabled={!ready}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder="ค้นหาตำแหน่ง"
          variant="outlined"
          onKeyDown={handleSearch}
          sx={{
            "& fieldset": {
              borderRadius: "10px",
            },
          }}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => handleSearch()}>
                  <SearchIcon />
                </IconButton>
                {value && (
                  <>
                    <Divider
                      sx={{ height: 28, m: 0.5 }}
                      orientation="vertical"
                    />
                    <IconButton onClick={() => setValue("")}>
                      <CloseIcon />
                    </IconButton>
                  </>
                )}
              </InputAdornment>
            ),
          }}
        />
      )}
    />
  );
};

export default PlacesAutoComplete;
